export class UnauthorizedError extends Error {
  constructor(details) {
    super("UnauthorizedError: ".concat(details.detail));
    this.detail = details.detail;
    this.title = details.title;
    this.type = details.type;
    this.code = details.code;
  }
}